module.exports = ["Links","ERC20Vendable","VendingMachine","Burner","BurnerVendor","Badges"]